<form  [formGroup]="reasonForm">
    <h5 class="sub-title mb-3">Reject Reason</h5>
    <div class="form-rows">
        <mat-form-field class="material-full-width" appearance="outline">
            <mat-label>Reject Reason
                <span class="text-danger">*</span></mat-label>
            <textarea matInput placeholder="Enter Reason"
                formControlName="reason" cols="30" rows="6"
                [ngClass]="{ 'is-invalid': add.reason.touched && add.reason.errors }"></textarea>
            <mat-error
                *ngIf="add.reason.touched && add.reason.errors">
                <span *ngIf="add.reason.errors.required">Reason is
                    required</span>
            </mat-error>
        </mat-form-field>
    </div>
    <div class="text-center mt-5">
        <button class="mr-2" mat-raised-button color="warn" (click)="cancelReason()">Cancel</button>
        <button mat-raised-button color="primary" (click)="saveReason()">Reject</button>
    </div>
</form>